import { render, staticRenderFns } from "./AllMerchantsSidebar.vue?vue&type=template&id=034b9bd4&scoped=true"
import script from "./AllMerchantsSidebar.vue?vue&type=script&lang=js"
export * from "./AllMerchantsSidebar.vue?vue&type=script&lang=js"
import style0 from "./AllMerchantsSidebar.vue?vue&type=style&index=0&id=034b9bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034b9bd4",
  null
  
)

export default component.exports